module.exports = __webpack_public_path__ + "img/to-sell.6f2897c4.png";